exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tag-font-size{font-size:1rem}@media (max-width:768px){.tag-font-size{font-size:.75rem}}.title-font-size{font-size:1.25rem}@media (max-width:768px){.title-font-size{font-size:1rem}}", ""]);

// exports
